import React from 'react';
import { Link } from 'react-router-dom';
export default function HomeLocation({ extraClass = "" }) {
   return (
      <>
         <section className={`home-location ${extraClass}`}>
            <div className="container">
               <div className="row justify-content-center">
                  <div className="col-md-12">
                     <div className="location-text">
                        <span className="subtitle">Service area</span>
                        <h2 className="heading">Map & Location</h2>
                        <ul className="location-links">
                           <li>
                              <Link to="https://maps.app.goo.gl/oWhZwSU2ZHDQgSiD8" target="_blank" >
                                 Edmonton </Link>
                           </li>
                           <li>
                              <Link to="https://maps.app.goo.gl/c2WYAg8cmaSzU5Bg7" target="_blank"   >
                                 Leduc</Link>
                           </li>
                           <li>
                              <Link to="https://maps.app.goo.gl/ccJ6Sy8pKEJpn3W86" target="_blank" >
                                 Spruce Grove</Link>
                           </li>
                           <li>
                              <Link to="https://maps.app.goo.gl/bFwPQVLRZnEKGAoX6" target="_blank"  >
                                 St Albert</Link>
                           </li>
                           <li>
                              <Link to="https://maps.app.goo.gl/F9mQtYuhREfn97uC6" target="_blank"  >
                                 Sherwood Park</Link>
                           </li>
                           <li>
                              <Link to="https://maps.app.goo.gl/LGSuoH7FEcGApH6o7" target="_blank"  >
                                 Nisku</Link>
                           </li>
                           <li>
                              <Link to="https://maps.app.goo.gl/NRmT4yu8ftVrkFE1A" target="_blank"  >
                                 Beaumont</Link>
                           </li>
                           <li>
                              <Link to="https://maps.app.goo.gl/EFSTMtkizjNRjo249" target="_blank"   >
                                 Acheson</Link>
                           </li>
                           <li>
                              <Link to="https://maps.app.goo.gl/Xv755eEZfyiMCqfj7" target="_blank"  >
                                 Parkland</Link>
                           </li>
                           <li>
                              <Link to="https://maps.app.goo.gl/o29DV6jAo5Lps8Jh7" target="_blank"   >
                                 Fort Saskatchewan </Link>
                           </li>
                           <li>
                              <Link to="https://maps.app.goo.gl/r6nEGRnMGg2Zenny7" target="_blank"   >
                                 Devon </Link>
                           </li>
                        </ul>
                        <div className="map-img">
                           <img src="/assets/images/home-location-map.webp" alt="Map" className="img-responsive" loading="lazy" />
                         
                           <div className="location_name parkland-location">
                              <a href="https://maps.app.goo.gl/Xv755eEZfyiMCqfj7" target="_blank" className="location_icon">
                                 <img src="/assets/images/location-icon1.webp" alt="location" loading="lazy" />
                              </a>
                              <span className="ripple">
                                 <span className="c1"></span>
                                 <span className="c2"></span></span>
                              <div className="location_m">
                                 <a href="https://maps.app.goo.gl/Xv755eEZfyiMCqfj7" target="_blank"  >Parkland</a>
                              </div>
                           </div>
                          
                           <div className="location_name  spruce-location">
                              <a href="https://maps.app.goo.gl/ccJ6Sy8pKEJpn3W86" target="_blank" className="location_icon">
                                 <img src="/assets/images/location-icon1.webp" alt="location" loading="lazy" />
                              </a>
                              <span className="ripple">
                                 <span className="c1"></span>
                                 <span className="c2"></span></span>
                              <div className="location_m  ">
                                 <a href="https://maps.app.goo.gl/ccJ6Sy8pKEJpn3W86" target="_blank" >Spruce Grove</a>
                              </div>
                           </div>
                           <div className="location_name  acheson-location">
                              <a href="https://maps.app.goo.gl/EFSTMtkizjNRjo249" target="_blank" className="location_icon">
                                 <img src="/assets/images/location-icon1.webp" alt="location" loading="lazy" />
                              </a>
                              <span className="ripple">
                                 <span className="c1"></span>
                                 <span className="c2"></span></span>
                              <div className="location_m  ">
                                 <a href="https://maps.app.goo.gl/EFSTMtkizjNRjo249" target="_blank" >Acheson</a>
                              </div>
                           </div>
                           <div className="location_name  devon-location">
                              <a href="https://maps.app.goo.gl/r6nEGRnMGg2Zenny7" target="_blank" className="location_icon">
                                 <img src="/assets/images/location-icon1.webp" alt="location" loading="lazy" />
                              </a>
                              <span className="ripple">
                                 <span className="c1"></span>
                                 <span className="c2"></span></span>
                              <div className="location_m  ">
                                 <a href="https://maps.app.goo.gl/r6nEGRnMGg2Zenny7" target="_blank" >Devon</a>
                              </div>
                           </div>
                           <div className="location_name  st-albert">
                              <a href="https://maps.app.goo.gl/bFwPQVLRZnEKGAoX6" target="_blank" className="location_icon">
                                 <img src="/assets/images/location-icon1.webp" alt="location" loading="lazy" />
                              </a>
                              <span className="ripple">
                                 <span className="c1"></span>
                                 <span className="c2"></span></span>
                              <div className="location_m  ">
                                 <a href="https://maps.app.goo.gl/bFwPQVLRZnEKGAoX6" target="_blank"  >ST Albert</a>
                              </div>
                           </div>
                           <div className="location_name  adonton-albert">
                              <a href="https://maps.app.goo.gl/oWhZwSU2ZHDQgSiD8" target="_blank" className="location_icon">
                                 <img src="/assets/images/location-icon1.webp" alt="location" loading="lazy" />
                              </a>
                              <span className="ripple">
                                 <span className="c1"></span>
                                 <span className="c2"></span></span>
                              <div className="location_m  ">
                                 <a href="https://maps.app.goo.gl/oWhZwSU2ZHDQgSiD8" target="_blank"  >Edmonton</a>
                              </div>
                           </div>
                           <div className="location_name  fort-albert">
                              <a href="https://maps.app.goo.gl/o29DV6jAo5Lps8Jh7" target="_blank" className="location_icon">
                                 <img src="/assets/images/location-icon1.webp" alt="location" loading="lazy" />
                              </a>
                              <span className="ripple">
                                 <span className="c1"></span>
                                 <span className="c2"></span></span>
                              <div className="location_m  ">
                                 <a href="https://maps.app.goo.gl/o29DV6jAo5Lps8Jh7" target="_blank"  >Fort Saskatchewan</a>
                              </div>
                           </div>
                           <div className="location_name  sherwood-albert">
                              <a href="https://maps.app.goo.gl/F9mQtYuhREfn97uC6" target="_blank" className="location_icon">
                                 <img src="/assets/images/location-icon1.webp" alt="location" loading="lazy" />
                              </a>
                              <span className="ripple">
                                 <span className="c1"></span>
                                 <span className="c2"></span></span>
                              <div className="location_m  ">
                                 <a href="https://maps.app.goo.gl/F9mQtYuhREfn97uC6" target="_blank"  >Sherwood Park</a>
                              </div>
                           </div>
                           <div className="location_name  nisku-albert">
                              <a href="https://maps.app.goo.gl/LGSuoH7FEcGApH6o7" target="_blank" className="location_icon">
                                 <img src="/assets/images/location-icon1.webp" alt="location" loading="lazy" />
                              </a>
                              <span className="ripple">
                                 <span className="c1"></span>
                                 <span className="c2"></span></span>
                              <div className="location_m  ">
                                 <a href="https://maps.app.goo.gl/LGSuoH7FEcGApH6o7" target="_blank" >Nisku</a>
                              </div>
                           </div>
                           <div className="location_name  beaumont-albert">
                              <a href="https://maps.app.goo.gl/NRmT4yu8ftVrkFE1A" target="_blank" className="location_icon">
                                 <img src="/assets/images/location-icon1.webp" alt="location" loading="lazy" />
                              </a>
                              <span className="ripple">
                                 <span className="c1"></span>
                                 <span className="c2"></span></span>
                              <div className="location_m  ">
                                 <a href="https://maps.app.goo.gl/NRmT4yu8ftVrkFE1A" target="_blank"  >Beaumont</a>
                              </div>
                           </div>
                           <div className="location_name  leduc-albert">
                              <a href="https://maps.app.goo.gl/c2WYAg8cmaSzU5Bg7" target="_blank" className="location_icon">
                                 <img src="/assets/images/location-icon1.webp" alt="location" loading="lazy" />
                              </a>
                              <span className="ripple">
                                 <span className="c1"></span>
                                 <span className="c2"></span></span>
                              <div className="location_m  ">
                                 <a href="https://maps.app.goo.gl/c2WYAg8cmaSzU5Bg7" target="_blank"  >Leduc</a>
                              </div>
                           </div>
                        </div>
                     </div>
                  <div className="location-paragraph">
                     <p>If your area is not in the map please <Link to="tel:+1 (780) 230 1359">give us a call +1 (780) 230 1359, </Link> to know if we service your area or not. </p>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </>
   )
}
